class TSCart extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const item = e.target.closest('[data-item]');
        switch (e.target.dataset.trigger) {
          case "close":
            this.classList.remove("open");
            document.body.style.overflow = null;
            break;
          case "remove":
            this.updateQuanity(parseInt(item.dataset.item), 0);
            break;
          case "decrease":
            this.updateQuanity(parseInt(item.dataset.item), parseInt(item.querySelector("input").value) - 1);
            break;
          case "increase":
            this.updateQuanity(parseInt(item.dataset.item), parseInt(item.querySelector("input").value) + 1);
            break;
        }
      }
    })

    document.querySelectorAll('[ts-cart]').forEach(cartTrigger => {
      cartTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.classList.toggle("open");
        if (!e.isTrusted) {
          this.resetCart();
        }
        document.body.style.overflow = "hidden";
      })
    })
  }

  updateQuanity(line, quantity) {
    this.toggleLoading();
    const data = {
      line: line,
      quantity: quantity,
      sections: ["ts-cart", "cart-icon-bubble"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      this.renderContent(response.sections)
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(this.toggleLoading.bind(this));
  }

  renderContent(sections) {
    const html = new DOMParser().parseFromString(sections['ts-cart'], "text/html");
    const selectors = [
      ".ts-cart__footer",
      ".ts-cart__content"
    ];

    this.querySelector(".ts-cart__content").classList = html.querySelector(".ts-cart__content").classList;

    selectors.forEach(selector => {
      if (this.querySelector(selector) && html.querySelector(selector)) {
        this.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
    })

    const iconMarkup = new DOMParser().parseFromString(sections['cart-icon-bubble'], "text/html");
    document.querySelector("#cart-icon-bubble").innerHTML = iconMarkup.querySelector("#shopify-section-cart-icon-bubble").innerHTML;
  }

  resetCart() {
    this.toggleLoading();
    fetch(window.location.href)
    .then(response => response.text())
    .then(response => {
      const html = new DOMParser().parseFromString(response, "text/html");
      const selectors = [
        ".ts-cart__footer",
        ".ts-cart__content"
      ];
  
      this.querySelector(".ts-cart__content").classList = html.querySelector(".ts-cart__content").classList
  
      selectors.forEach(selector => {
        if (this.querySelector(selector) && html.querySelector(selector)) {
          this.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        }
      })
  
      document.querySelector("#cart-icon-bubble").innerHTML = html.querySelector("#cart-icon-bubble").innerHTML;
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(this.toggleLoading.bind(this));
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-cart", TSCart)